import { instance } from '@shared/api/config';
import { path } from '../../config';

export const getDebtsByOsiId = (
  osiId: number,
  period: {
    begin: any;
    end: any;
  },
  // Флаг «Свернуть дочерние помещения»: при true дописываем query-параметр для бэкенда oci-docs
  collapseChildren = false
): Promise<any> =>
  instance.get(
    `${path}/debts/${osiId}?begin=${period.begin}&end=${period.end}${
      collapseChildren ? '&collapseChildren=true' : ''
    }`
  );
